import React, {useEffect, useState} from "react"
import {SubmitState} from "../../../components-shared/forms/form-submit-button/form-submit-button"
import {ImportModalView, VisibleValidationResults} from "./import-modal-view"
import {Bank} from "./bank-format"
import {useServices} from "../../../services/services"
import {ImportTransactionsFailureResponse, ImportTransactionsSuccessResponse} from "../../../services/api/transactions-api"

interface ImportModalProps {
  show: boolean
  closeModal: () => void
  onSuccess: (importTransactionsSuccessResponse: ImportTransactionsSuccessResponse) => void
}

const InitiallyVisibleValidationResult: VisibleValidationResults = {
  bank: false,
  file: false
}

const AllValidationResultVisible: VisibleValidationResults = {
  bank: true,
  file: true
}

export const ImportModal : React.FC<ImportModalProps> = ({ show, closeModal, onSuccess }) => {
  const services = useServices()
  const [bank, setBank] = useState<Bank | null>(null)
  const [fileName, setFileName] = useState<string>("")
  const [visibleValidationResults, setVisibleValidationResults] = useState<VisibleValidationResults>(InitiallyVisibleValidationResult)
  const [importSubmitState, setImportSubmitState] = useState<SubmitState>(SubmitState.Initial)
  const [importFailureResponse, setImportFailureResponse] = useState<ImportTransactionsFailureResponse | null>(null)

  useEffect(() => {
    if (importSubmitState !== SubmitState.Initial) setImportSubmitState(SubmitState.Initial)
    if (importFailureResponse !== null) setImportFailureResponse(null)
    if (bank !== null) setBank(null)
    if (fileName !== null) setFileName("")
    setVisibleValidationResults(InitiallyVisibleValidationResult)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const handleBlur = (field: "bank" | "file") => {
    if (!visibleValidationResults[field]) setVisibleValidationResults({...visibleValidationResults, [field]: true})
  }

  const handleSubmit = async (bank: Bank | null, file: File | null) => {
    setVisibleValidationResults(AllValidationResultVisible)

    if (bank !== null && file !== null) {
      try {
        setImportSubmitState(SubmitState.Submitting)
        const response = await services?.transactionsApi.importTransactions(bank, file)
        setImportSubmitState(SubmitState.Initial)

        if (response?.success !== undefined) {
          closeModal()
          onSuccess(response.success)
        } else if (response?.failure) {
          setImportFailureResponse(response.failure)
        }
      } catch (err) {
        setImportSubmitState(SubmitState.Initial)
      }
    }
  }

  return <ImportModalView show={show} bank={bank} setBank={setBank} fileName={fileName} setFileName={setFileName} onBlur={handleBlur} visibleValidationResults={visibleValidationResults} closeModal={closeModal} onSubmit={handleSubmit} importSubmitState={importSubmitState} importFailureResponse={importFailureResponse}/>
}
